import validate from "/app/node_modules/.pnpm/nuxt@3.7.0_@parcel+watcher@2.3.0_@types+node@20.4.7_encoding@0.1.13_eslint@8.49.0_optionator@_rawm7zxdkkcslgg7hpa2pibc6y/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/app/middleware/router.global.ts";
export const globalMiddleware = [
  validate,
  router_45global
]
export const namedMiddleware = {
  keepalive: () => import("/app/middleware/keepalive.ts")
}